import type { NavigationSection } from "@repo/types";

export const appNavigation: NavigationSection[] = [];

export const platformAdminNavigation: NavigationSection[] = [
  {
    id: "overview",
    label: "平台統覽",
    items: [
      {
        id: "admin-dashboard",
        label: "租戶儀表板",
        href: "/platform-admin/tenants",
        description: "即時掌握租戶方案與營運績效。"
      },
      {
        id: "plans",
        label: "方案管理",
        href: "/platform-admin/plans",
        description: "維護訂閱方案、月費與模組權限。"
      },
      {
        id: "website-content",
        label: "行銷網站管理",
        href: "/platform-admin/website-content",
        description: "編輯官網文字內容，左側編輯、右側即時預覽。"
      }
    ]
  },
  {
    id: "ops",
    label: "營運管理",
    items: [
      {
        id: "wallets",
        label: "儲值金管理",
        href: "/platform-admin/wallets",
        description: "跨租戶檢視儲值帳戶並手動調整。"
      },
      {
        id: "subscription-requests",
        label: "訂閱審核",
        href: "/platform-admin/subscriptions",
        description: "審核租戶付款申請並啟用或退回方案。"
      },
      {
        id: "subscription-addon-requests",
        label: "資源加購審核",
        href: "/platform-admin/subscription-addons",
        description: "審核租戶的員工／服務項目／商品／設備自助加購申請。"
      },
      {
        id: "payment-confirmations",
        label: "每月收款確認",
        href: "/platform-admin/payment-confirmations",
        description: "確認租戶回報的每月匯款，核准後延長訂閱到期日。"
      },
      {
        id: "integration-requests",
        label: "串接申請",
        href: "/platform-admin/integration-requests",
        description: "審核租戶 LINE 串接申請並設定 credentials。"
      },
      {
        id: "payment-methods",
        label: "支付方式",
        href: "/platform-admin/payment-methods",
        description: "管理租戶向顧客收款可用的支付方式。"
      },
      {
        id: "subscription-payment-channels",
        label: "訂閱收款方式",
        href: "/platform-admin/subscription-payment-channels",
        description: "管理租戶付訂閱費用給平台時可選的付款方式與帳號。"
      },
      {
        id: "menu-management",
        label: "選單與模組",
        href: "/platform-admin/menu-management",
        description: "管理選單分區、租戶覆寫與試用模組設定。"
      }
    ]
  },
  {
    id: "support",
    label: "支援洞察",
    items: [
      {
        id: "messages",
        label: "客服中心",
        href: "/platform-admin/support",
        description: "協助租戶處理票證與產品建議。"
      },
      {
        id: "account-deletion-requests",
        label: "刪除帳號申請",
        href: "/platform-admin/account-deletion-requests",
        description: "集中審核刪除帳號申請，並由平台管理端執行帳號刪除。"
      },
      {
        id: "users",
        label: "使用者管理",
        href: "/platform-admin/users",
        description: "檢視與管理所有使用者帳號、修改密碼。"
      },
      {
        id: "customers",
        label: "顧客管理",
        href: "/platform-admin/customers",
        description: "檢視與管理所有租戶的顧客資料。"
      },
      {
        id: "scheduler-settings",
        label: "系統排程設定",
        href: "/platform-admin/scheduler-settings",
        description: "控制生日優惠券發放、訂閱檢查、預約提醒等排程的執行時間。"
      }
    ]
  }
];
